import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ErrorBoundary } from './Components/ErrorBoundary/ErrorBoundary';
import { initSystemLogger } from './Services/SystemLogger';

initSystemLogger();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
